export function getIconComponent(iconPath: string) {
	let svgIcon;

	try {
		svgIcon = require(`public/media/icons/${iconPath}.svg`);
	} catch {
		svgIcon = null;
	}

	if (svgIcon) {
		return svgIcon.ReactComponent;
	}

	return null;
}
